import { Component, Input, OnInit } from '@angular/core';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import {
  ParamGeneralFieldRepository,
  ParamGeneralFieldRepositoryFactory,
  ParamGeneralFieldStore,
} from '@/store/dac-general-params-state/param-general-field-state/param-general-field.repository';
import { getFormBuilderObjectFactory } from '@/components/form-builder/utils/form-builder-factory';
import { getParamGeneralFieldFormObject } from './utils/param-general-field.form-object';
import { DynamicForm } from '@/components/form-builder/form-builder.types';

@Component({
  selector: 'sm-param-general-field-form',
  imports: [FormBuilderComponent],
  template: `
    <div class="flex flex-col gap-5 m-4 mb-0">
      <sm-form-builder [formObject]="formObject"></sm-form-builder>
    </div>
  `,
})
export class ParamGeneralFieldFormComponent implements OnInit {
  @Input() store?: ParamGeneralFieldStore;

  fieldRepository?: ParamGeneralFieldRepository;
  formObject: DynamicForm = getFormBuilderObjectFactory();

  ngOnInit() {
    this.buildFormObject();
  }

  private buildFormObject() {
    if (this.store) {
      this.fieldRepository = ParamGeneralFieldRepositoryFactory.create(this.store);
      this.formObject = getParamGeneralFieldFormObject({ store: this.fieldRepository });
    }
  }
}
